{
  "three-acts": {
    "name": "Três atos",
    "summary": "Apresentação, confronto e resolução: a estrutura que a maioria dos romances e filmes compartilha.",
    "bestFor": "Qualquer gênero e um primeiro rascunho que você queira manter simples.",
    "metaTitle": "Modelo de história em três atos — Musael",
    "metaDescription": "Apresentação, confronto e resolução: a estrutura de muitos romances e filmes. Para qualquer gênero e um primeiro rascunho simples.",
    "acts": [
      {
        "title": "Ato I: Apresentação",
        "synopsis": "Quem é o protagonista, o que ele quer e o acontecimento que encerra sua vida normal.",
        "chapters": [
          {
            "title": "O mundo comum",
            "synopsis": "O protagonista em seu ambiente, com o desejo e a falha que a história colocará à prova.",
            "scenes": [
              {
                "title": "Imagem de abertura",
                "synopsis": "Um retrato do protagonista antes de qualquer mudança."
              },
              {
                "title": "O gancho",
                "synopsis": "Algo pequeno, mas estranho, que anuncia problemas."
              }
            ]
          },
          {
            "title": "O incidente incitante",
            "synopsis": "O acontecimento que o protagonista não pode ignorar.",
            "scenes": [
              {
                "title": "Incidente incitante",
                "synopsis": "O problema chega e não vai embora."
              },
              {
                "title": "Dilema",
                "synopsis": "O protagonista hesita, e vemos o que ele pode perder."
              }
            ]
          },
          {
            "title": "A travessia do limiar",
            "synopsis": "O protagonista se compromete; não há um caminho fácil de volta.",
            "scenes": [
              {
                "title": "A decisão",
                "synopsis": "O protagonista escolhe agir e deixa o conhecido para trás."
              }
            ]
          }
        ]
      },
      {
        "title": "Ato II: Confronto",
        "synopsis": "O protagonista tenta, falha e aprende, enquanto cada vez mais está em jogo.",
        "chapters": [
          {
            "title": "Os riscos aumentam",
            "synopsis": "Novas regras, aliados e inimigos; as primeiras vitórias têm um preço.",
            "scenes": [
              {
                "title": "Primeiro teste",
                "synopsis": "O protagonista encontra o novo mundo e o interpreta parcialmente errado."
              },
              {
                "title": "Aliados e inimigos",
                "synopsis": "Quem ajuda, quem atrapalha e por quê."
              }
            ]
          },
          {
            "title": "O ponto médio",
            "synopsis": "Uma reviravolta que muda o sentido da história.",
            "scenes": [
              {
                "title": "Ponto médio",
                "synopsis": "Uma falsa vitória ou derrota; o protagonista deixa de reagir e assume a iniciativa."
              }
            ]
          },
          {
            "title": "Tudo desmorona",
            "synopsis": "A oposição se aproxima, e a falha custa caro ao protagonista.",
            "scenes": [
              {
                "title": "O cerco aperta",
                "synopsis": "Todos os planos enfrentam resistência; as relações se abalam."
              },
              {
                "title": "Tudo está perdido",
                "synopsis": "O ponto mais baixo: o objetivo parece definitivamente fora de alcance."
              }
            ]
          }
        ]
      },
      {
        "title": "Ato III: Resolução",
        "synopsis": "O protagonista muda, enfrenta o teste final e uma nova normalidade começa.",
        "chapters": [
          {
            "title": "O clímax",
            "synopsis": "O confronto final, vencido graças à lição do segundo ato.",
            "scenes": [
              {
                "title": "O plano final",
                "synopsis": "O protagonista reúne o que aprendeu e faz uma última tentativa."
              },
              {
                "title": "Clímax",
                "synopsis": "O confronto decisivo."
              }
            ]
          },
          {
            "title": "A nova normalidade",
            "synopsis": "O que mudou para o protagonista e para o mundo.",
            "scenes": [
              {
                "title": "Imagem de encerramento",
                "synopsis": "Um espelho da imagem de abertura, mostrando o caminho percorrido pelo protagonista."
              }
            ]
          }
        ]
      }
    ]
  },
  "heros-journey": {
    "name": "A jornada do herói",
    "summary": "Doze etapas do chamado à aventura à volta para casa, agrupadas em partida, iniciação e retorno.",
    "bestFor": "Fantasia, aventura e jornadas de busca.",
    "metaTitle": "Modelo da jornada do herói — Musael",
    "metaDescription": "Doze etapas do chamado à aventura à volta para casa: partida, iniciação e retorno. Para fantasia, aventura e jornadas de busca.",
    "acts": [
      {
        "title": "Partida",
        "synopsis": "O protagonista deixa o mundo conhecido.",
        "chapters": [
          {
            "title": "O mundo comum",
            "synopsis": "O protagonista antes da aventura: lar, hábitos e o que falta.",
            "scenes": [
              {
                "title": "O mundo comum",
                "synopsis": "O protagonista antes da aventura: lar, hábitos e o que falta."
              }
            ]
          },
          {
            "title": "O chamado à aventura",
            "synopsis": "Um desafio ou uma mensagem perturba o mundo comum.",
            "scenes": [
              {
                "title": "O chamado à aventura",
                "synopsis": "Um desafio ou uma mensagem perturba o mundo comum."
              }
            ]
          },
          {
            "title": "Recusa do chamado",
            "synopsis": "O medo ou o dever impede o protagonista de avançar.",
            "scenes": [
              {
                "title": "Recusa do chamado",
                "synopsis": "O medo ou o dever impede o protagonista de avançar."
              }
            ]
          },
          {
            "title": "Encontro com o mentor",
            "synopsis": "Alguém oferece conselho, treinamento ou um presente.",
            "scenes": [
              {
                "title": "Encontro com o mentor",
                "synopsis": "Alguém oferece conselho, treinamento ou um presente."
              }
            ]
          },
          {
            "title": "Travessia do primeiro limiar",
            "synopsis": "O protagonista entra no mundo extraordinário.",
            "scenes": [
              {
                "title": "Travessia do primeiro limiar",
                "synopsis": "O protagonista entra no mundo extraordinário."
              }
            ]
          }
        ]
      },
      {
        "title": "Iniciação",
        "synopsis": "Testes no mundo extraordinário e a grande provação.",
        "chapters": [
          {
            "title": "Testes, aliados e inimigos",
            "synopsis": "O protagonista aprende as regras do novo mundo.",
            "scenes": [
              {
                "title": "Testes, aliados e inimigos",
                "synopsis": "O protagonista aprende as regras do novo mundo."
              }
            ]
          },
          {
            "title": "Aproximação da caverna mais profunda",
            "synopsis": "Preparativos para o perigo central.",
            "scenes": [
              {
                "title": "Aproximação da caverna mais profunda",
                "synopsis": "Preparativos para o perigo central."
              }
            ]
          },
          {
            "title": "A provação",
            "synopsis": "Uma crise de vida ou morte; algo dentro do protagonista morre.",
            "scenes": [
              {
                "title": "A provação",
                "synopsis": "Uma crise de vida ou morte; algo dentro do protagonista morre."
              }
            ]
          },
          {
            "title": "A recompensa",
            "synopsis": "O protagonista conquista o tesouro, o conhecimento ou a reconciliação.",
            "scenes": [
              {
                "title": "A recompensa",
                "synopsis": "O protagonista conquista o tesouro, o conhecimento ou a reconciliação."
              }
            ]
          }
        ]
      },
      {
        "title": "Retorno",
        "synopsis": "O caminho para casa, um último teste e o que o protagonista traz de volta.",
        "chapters": [
          {
            "title": "O caminho de volta",
            "synopsis": "O protagonista volta para casa, muitas vezes perseguido.",
            "scenes": [
              {
                "title": "O caminho de volta",
                "synopsis": "O protagonista volta para casa, muitas vezes perseguido."
              }
            ]
          },
          {
            "title": "Ressurreição",
            "synopsis": "Um teste final em que tudo o que foi aprendido entra em prática.",
            "scenes": [
              {
                "title": "Ressurreição",
                "synopsis": "Um teste final em que tudo o que foi aprendido entra em prática."
              }
            ]
          },
          {
            "title": "Retorno com o elixir",
            "synopsis": "O protagonista volta para casa transformado, com algo para compartilhar.",
            "scenes": [
              {
                "title": "Retorno com o elixir",
                "synopsis": "O protagonista volta para casa transformado, com algo para compartilhar."
              }
            ]
          }
        ]
      }
    ]
  },
  "fifteen-beats": {
    "name": "Esquema de quinze momentos",
    "summary": "O esquema usado por roteiristas: quinze viradas distribuídas em três atos.",
    "bestFor": "Tramas comerciais enxutas, com viradas claras.",
    "metaTitle": "Modelo narrativo de quinze momentos — Musael",
    "metaDescription": "O esquema dos roteiristas: quinze viradas em três atos. Para tramas comerciais enxutas, com pontos de virada claros.",
    "acts": [
      {
        "title": "Ato I",
        "synopsis": "O mundo de antes e a escolha de deixá-lo.",
        "chapters": [
          {
            "title": "Imagem de abertura",
            "synopsis": "O protagonista e o mundo antes da história.",
            "scenes": [
              {
                "title": "Imagem de abertura",
                "synopsis": "O protagonista e o mundo antes da história."
              }
            ]
          },
          {
            "title": "Apresentação do tema",
            "synopsis": "Alguém diz do que a história realmente trata; o protagonista ainda não percebe.",
            "scenes": [
              {
                "title": "Apresentação do tema",
                "synopsis": "Alguém diz do que a história realmente trata; o protagonista ainda não percebe."
              }
            ]
          },
          {
            "title": "Apresentação",
            "synopsis": "A vida do protagonista, as pessoas nela e o que precisa ser consertado.",
            "scenes": [
              {
                "title": "Apresentação",
                "synopsis": "A vida do protagonista, as pessoas nela e o que precisa ser consertado."
              }
            ]
          },
          {
            "title": "Catalisador",
            "synopsis": "O acontecimento que põe a história em movimento.",
            "scenes": [
              {
                "title": "Catalisador",
                "synopsis": "O acontecimento que põe a história em movimento."
              }
            ]
          },
          {
            "title": "Dilema",
            "synopsis": "O protagonista não sabe o que fazer.",
            "scenes": [
              {
                "title": "Dilema",
                "synopsis": "O protagonista não sabe o que fazer."
              }
            ]
          },
          {
            "title": "Entrada no segundo ato",
            "synopsis": "O protagonista escolhe um novo caminho.",
            "scenes": [
              {
                "title": "Entrada no segundo ato",
                "synopsis": "O protagonista escolhe um novo caminho."
              }
            ]
          }
        ]
      },
      {
        "title": "Ato II",
        "synopsis": "A promessa da premissa, depois a queda.",
        "chapters": [
          {
            "title": "Trama secundária",
            "synopsis": "Uma história secundária, muitas vezes um relacionamento, que carrega o tema.",
            "scenes": [
              {
                "title": "Trama secundária",
                "synopsis": "Uma história secundária, muitas vezes um relacionamento, que carrega o tema."
              }
            ]
          },
          {
            "title": "Diversão e jogos",
            "synopsis": "A premissa se concretiza: aquilo que trouxe os leitores até aqui.",
            "scenes": [
              {
                "title": "Diversão e jogos",
                "synopsis": "A premissa se concretiza: aquilo que trouxe os leitores até aqui."
              }
            ]
          },
          {
            "title": "Ponto médio",
            "synopsis": "Uma falsa vitória ou derrota aumenta o que está em jogo.",
            "scenes": [
              {
                "title": "Ponto médio",
                "synopsis": "Uma falsa vitória ou derrota aumenta o que está em jogo."
              }
            ]
          },
          {
            "title": "Os adversários se aproximam",
            "synopsis": "Dúvida por dentro, pressão por fora.",
            "scenes": [
              {
                "title": "Os adversários se aproximam",
                "synopsis": "Dúvida por dentro, pressão por fora."
              }
            ]
          },
          {
            "title": "Tudo está perdido",
            "synopsis": "O oposto do ponto médio: o momento mais baixo.",
            "scenes": [
              {
                "title": "Tudo está perdido",
                "synopsis": "O oposto do ponto médio: o momento mais baixo."
              }
            ]
          },
          {
            "title": "A noite escura da alma",
            "synopsis": "O protagonista lamenta o que perdeu e encontra a lição.",
            "scenes": [
              {
                "title": "A noite escura da alma",
                "synopsis": "O protagonista lamenta o que perdeu e encontra a lição."
              }
            ]
          }
        ]
      },
      {
        "title": "Ato III",
        "synopsis": "A lição aplicada.",
        "chapters": [
          {
            "title": "Entrada no terceiro ato",
            "synopsis": "Uma nova ideia, vinda da trama secundária, abre um caminho.",
            "scenes": [
              {
                "title": "Entrada no terceiro ato",
                "synopsis": "Uma nova ideia, vinda da trama secundária, abre um caminho."
              }
            ]
          },
          {
            "title": "Final",
            "synopsis": "O protagonista conserta o que estava quebrado, transformado de vez.",
            "scenes": [
              {
                "title": "Final",
                "synopsis": "O protagonista conserta o que estava quebrado, transformado de vez."
              }
            ]
          },
          {
            "title": "Imagem final",
            "synopsis": "O mundo depois, espelhando a imagem de abertura.",
            "scenes": [
              {
                "title": "Imagem final",
                "synopsis": "O mundo depois, espelhando a imagem de abertura."
              }
            ]
          }
        ]
      }
    ]
  },
  "seven-point": {
    "name": "Estrutura de sete pontos",
    "summary": "Planeje de trás para a frente a partir do final: gancho, viradas, pressões, ponto médio e resolução.",
    "bestFor": "Escritores que conhecem primeiro o final.",
    "metaTitle": "Modelo narrativo de sete pontos — Musael",
    "metaDescription": "Planeje a partir do final: gancho, viradas, pressões, ponto médio e resolução. Para escritores que conhecem primeiro o desfecho.",
    "acts": [
      {
        "title": "",
        "synopsis": "",
        "chapters": [
          {
            "title": "Gancho",
            "synopsis": "O estado inicial, oposto ao da resolução.",
            "scenes": [
              {
                "title": "Gancho",
                "synopsis": "O estado inicial, oposto ao da resolução."
              }
            ]
          },
          {
            "title": "Virada da trama 1",
            "synopsis": "O conflito começa, e o protagonista é levado a agir.",
            "scenes": [
              {
                "title": "Virada da trama 1",
                "synopsis": "O conflito começa, e o protagonista é levado a agir."
              }
            ]
          },
          {
            "title": "Pressão 1",
            "synopsis": "O antagonista pressiona; o protagonista precisa agir.",
            "scenes": [
              {
                "title": "Pressão 1",
                "synopsis": "O antagonista pressiona; o protagonista precisa agir."
              }
            ]
          },
          {
            "title": "Ponto médio",
            "synopsis": "O protagonista passa de reagir a agir.",
            "scenes": [
              {
                "title": "Ponto médio",
                "synopsis": "O protagonista passa de reagir a agir."
              }
            ]
          },
          {
            "title": "Pressão 2",
            "synopsis": "As coisas dão muito errado; o plano falha.",
            "scenes": [
              {
                "title": "Pressão 2",
                "synopsis": "As coisas dão muito errado; o plano falha."
              }
            ]
          },
          {
            "title": "Virada da trama 2",
            "synopsis": "O protagonista consegue a última peça necessária para vencer.",
            "scenes": [
              {
                "title": "Virada da trama 2",
                "synopsis": "O protagonista consegue a última peça necessária para vencer."
              }
            ]
          },
          {
            "title": "Resolução",
            "synopsis": "O estado final, a resposta ao gancho.",
            "scenes": [
              {
                "title": "Resolução",
                "synopsis": "O estado final, a resposta ao gancho."
              }
            ]
          }
        ]
      }
    ]
  },
  "kishotenketsu": {
    "name": "Kishōtenketsu",
    "summary": "Quatro movimentos construídos sobre uma virada, em vez de um conflito.",
    "bestFor": "Ficção literária, contos e livros tranquilos centrados nos personagens.",
    "metaTitle": "Modelo narrativo Kishōtenketsu — Musael",
    "metaDescription": "Quatro movimentos baseados em uma virada, não em um conflito. Para ficção literária, contos e livros tranquilos centrados nos personagens.",
    "acts": [
      {
        "title": "",
        "synopsis": "",
        "chapters": [
          {
            "title": "Ki: introdução",
            "synopsis": "Os personagens e seu mundo, com calma.",
            "scenes": [
              {
                "title": "Introdução",
                "synopsis": "Quem, onde e como é o cotidiano."
              }
            ]
          },
          {
            "title": "Shō: desenvolvimento",
            "synopsis": "A situação se aprofunda, ainda sem uma virada.",
            "scenes": [
              {
                "title": "Desenvolvimento",
                "synopsis": "Conhecemos melhor os personagens; pequenas coisas mudam."
              }
            ]
          },
          {
            "title": "Ten: virada",
            "synopsis": "Um elemento inesperado muda a forma como vemos tudo.",
            "scenes": [
              {
                "title": "A virada",
                "synopsis": "Chega algo novo, aparentemente sem relação."
              }
            ]
          },
          {
            "title": "Ketsu: reconciliação",
            "synopsis": "As partes se unem em uma nova compreensão.",
            "scenes": [
              {
                "title": "Reconciliação",
                "synopsis": "A virada e a história se encontram; o significado muda."
              }
            ]
          }
        ]
      }
    ]
  },
  "mystery": {
    "name": "Mistério",
    "summary": "Um crime, uma investigação entre pistas e pistas falsas, e uma revelação justa com o leitor.",
    "bestFor": "Histórias policiais, de detetive e mistérios cozy.",
    "metaTitle": "Modelo narrativo de mistério — Musael",
    "metaDescription": "Um crime, pistas, pistas falsas e uma revelação justa com o leitor. Para histórias policiais, de detetive e mistérios cozy.",
    "acts": [
      {
        "title": "O crime",
        "synopsis": "Algo está errado, e alguém precisa descobrir por quê.",
        "chapters": [
          {
            "title": "A descoberta",
            "synopsis": "O crime ou o desaparecimento.",
            "scenes": [
              {
                "title": "O corpo",
                "synopsis": "O crime é descoberto; primeiras impressões e primeiras perguntas."
              },
              {
                "title": "O detetive",
                "synopsis": "Quem investiga e por que isso importa para essa pessoa."
              }
            ]
          }
        ]
      },
      {
        "title": "A investigação",
        "synopsis": "Pistas, suspeitos e pistas falsas.",
        "chapters": [
          {
            "title": "Suspeitos",
            "synopsis": "Todos que têm um motivo e um álibi.",
            "scenes": [
              {
                "title": "Entrevistas",
                "synopsis": "Cada suspeito ganha um motivo para mentir."
              },
              {
                "title": "A primeira pista",
                "synopsis": "Um fato que importará depois; seja justo com o leitor."
              }
            ]
          },
          {
            "title": "Pistas falsas",
            "synopsis": "A investigação segue na direção errada.",
            "scenes": [
              {
                "title": "Uma pista enganosa",
                "synopsis": "As provas apontam para a pessoa errada."
              },
              {
                "title": "Escalada",
                "synopsis": "Um segundo crime ou uma ameaça aumenta o que está em jogo."
              }
            ]
          },
          {
            "title": "A verdade oculta",
            "synopsis": "O detetive enxerga o que sempre esteve ali.",
            "scenes": [
              {
                "title": "A peça que falta",
                "synopsis": "Um pequeno detalhe faz as pistas anteriores se encaixarem."
              }
            ]
          }
        ]
      },
      {
        "title": "A revelação",
        "synopsis": "A solução e seu preço.",
        "chapters": [
          {
            "title": "A solução",
            "synopsis": "Todas as pistas são explicadas.",
            "scenes": [
              {
                "title": "A revelação",
                "synopsis": "O culpado é identificado e o raciocínio é apresentado."
              },
              {
                "title": "As consequências",
                "synopsis": "A justiça, ou sua ausência, e o que o detetive leva consigo."
              }
            ]
          }
        ]
      }
    ]
  },
  "romance": {
    "name": "História de amor",
    "summary": "Duas pessoas, o que as mantém separadas e o que precisam para escolher uma à outra.",
    "bestFor": "Romances e histórias de amor em qualquer cenário.",
    "metaTitle": "Modelo de história de amor — Musael",
    "metaDescription": "Duas pessoas, o que as separa e o que precisam para escolher uma à outra. Para romances e histórias de amor em qualquer cenário.",
    "acts": [
      {
        "title": "Apaixonar-se",
        "synopsis": "Elas se encontram, resistem e começam a se apaixonar.",
        "chapters": [
          {
            "title": "O encontro",
            "synopsis": "O primeiro encontro, com a faísca e o obstáculo.",
            "scenes": [
              {
                "title": "Encontro",
                "synopsis": "Os dois protagonistas se conhecem; algo no outro mexe profundamente com cada um."
              },
              {
                "title": "Resistência",
                "synopsis": "Por que isso não pode funcionar: objetivos, feridas ou circunstâncias."
              }
            ]
          },
          {
            "title": "Aproximação",
            "synopsis": "Obrigados a conviver, enxergam um ao outro de verdade.",
            "scenes": [
              {
                "title": "Juntos por acaso",
                "synopsis": "Uma situação os mantém próximos."
              },
              {
                "title": "O primeiro momento verdadeiro",
                "synopsis": "Um vislumbre de quem o outro realmente é."
              }
            ]
          }
        ]
      },
      {
        "title": "Duvidar",
        "synopsis": "O compromisso, depois o medo que o desfaz.",
        "chapters": [
          {
            "title": "O ponto médio",
            "synopsis": "Eles cedem ao que sentem.",
            "scenes": [
              {
                "title": "Compromisso",
                "synopsis": "Um beijo, uma confissão ou uma promessa."
              }
            ]
          },
          {
            "title": "A ruptura",
            "synopsis": "A velha ferida ou o obstáculo externo vence, por enquanto.",
            "scenes": [
              {
                "title": "Dúvida",
                "synopsis": "Os velhos medos voltam."
              },
              {
                "title": "A separação",
                "synopsis": "Eles se separam, cada um convencido de ter razão."
              }
            ]
          }
        ]
      },
      {
        "title": "Escolher",
        "synopsis": "Crescimento, um grande gesto e um futuro compartilhado.",
        "chapters": [
          {
            "title": "Juntos",
            "synopsis": "Cada um muda o suficiente para merecer o outro.",
            "scenes": [
              {
                "title": "O grande gesto",
                "synopsis": "Um deles arrisca tudo para mostrar que mudou."
              },
              {
                "title": "Felizes para sempre",
                "synopsis": "Ou felizes por enquanto: o futuro que escolhem."
              }
            ]
          }
        ]
      }
    ]
  }
}
